module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售通话记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "通话日期:"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.defaultDate,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "默认当天"
    },
    on: {
      "on-change": _vm.atimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "被呼叫的号码",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "员工名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "员工名称",
      "name": "ecUserName"
    },
    model: {
      value: (_vm.queryParam.ecUserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ecUserName", $$v)
      },
      expression: "queryParam.ecUserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n              搜索\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.syncSalesUser
    }
  }, [_vm._v("同步销售工号")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.SynchronousData
    }
  }, [_vm._v("同步记录")])], 1)], 1), _vm._v(" "), _c('List', {
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/call_record/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": "/crm/PhoneRecordList",
      "default-task-type": "SALES_FOLLOWUP"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361c80b9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/PhoneRecordList.vue
// module id = 1750
// module chunks = 8